const settingsConfig = {
	layout: {
		style: 'layout1', // checkout default layout configs at app/fuse-layouts
		config: {}
	},
	customScrollbars: false,
	animations: true,
	direction: 'ltr', // rtl, ltr
	theme: {
		main: 'default',
		navbar: 'mainThemeDark',
		toolbar: 'mainThemeLight',
		footer: 'mainThemeDark'
	}
};

export default settingsConfig;
